import { useContext } from 'react';
import { TargetContext } from './context';

function useTarget() {
  const context = useContext(TargetContext);

  if (!context) {
    throw new Error('useTarget must be used within a TargetProvider');
  }

  return context;
}

export { useTarget };
